var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"forChild"},[_c('Parallax'),_c('ProblemsText'),_c('Hope'),_c('Reviews'),_c('Mentors'),_c('RoadMap'),_c('CoursesSlider'),_c('FAQ'),_c('Courses'),_c('Discont')],1)}
var staticRenderFns = []

export { render, staticRenderFns }